import { useFaireDirectFirstOrderIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";

export const useHasFaireDirectIncentiveNudge = () => {
  const { isLastDayBeforeExpiry, hasIncentiveAndBrandIsBasedInCanadaOrUSA } =
    useFaireDirectFirstOrderIncentive();

  return isLastDayBeforeExpiry && hasIncentiveAndBrandIsBasedInCanadaOrUSA;
};
